import { Button, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

export function SupplierShipmentsEmptyState() {
  const navigate = useNavigate();

  const handleAddSuppliersClick = () => {
    navigate("/supplier-network");
  };

  return (
    <Stack
      direction="column"
      justifyContent="center"
      alignItems="center"
      spacing={2}
      sx={{ py: "4rem" }}
    >
      <Typography textAlign="center" variant="body1">
        You have no supplier shipments yet.
      </Typography>
      <Typography textAlign="center" variant="body2" color="textSecondary">
        Connect with suppliers to start receiving shipments from your network.
      </Typography>
      <Button
        variant="contained"
        onClick={handleAddSuppliersClick}
        sx={{ mt: 2 }}
      >
        Add Suppliers
      </Button>
    </Stack>
  );
}
